export const getCheapestRentalSuffix = (rentalKey) => {
    switch (rentalKey) {
        case 'rental_day_price':
            return ' per dag';
        case 'rental_weekend_price':
            return ' per weekend';
        case 'rental_midweek_price':
            return ' per midweek';
        case 'rental_week_price':
            return ' per week';
        case 'rental_month_price':
            return ' per maand';
        default:
            return '';
    }
}
